/* Grable "real home" product videos (Oct 2026)
   - plays the small/in-page videos (muted) only while they are on screen
   - opens a full-screen viewer (one or several videos, story style) with a Buy Now button
     wired to the page's own Buy Now / Add to cart */
(function () {
  if (window.GrableRealVideo) return;
  window.GrableRealVideo = true;

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var ICON_PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 4l14 8-14 8z"/></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_PREV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  var ICON_MUTED = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M11 5L6 9H3v6h3l5 4zM16 9l5 6M21 9l-5 6"/></svg>';
  var ICON_SOUND = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M11 5L6 9H3v6h3l5 4zM15.5 8.5a5 5 0 010 7M18.5 5.5a9 9 0 010 13"/></svg>';

  var DATA = null;
  var viewer = null, video, progress, soundBtn, buyBtn, titleEl, priceEl, imgEl, stage, prevBtn, nextBtn, countEl;
  var opener = null, pushed = false, afterClose = null, inline = [], current = 0;

  function data() {
    if (DATA) return DATA;
    var el = document.getElementById('GrableRealVideoData');
    try { DATA = el ? JSON.parse(el.textContent) : null; } catch (e) { DATA = null; }
    if (DATA && !(DATA.videos && DATA.videos.length)) DATA = null;
    return DATA;
  }
  function track(action) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'grable_video', video_action: action, video_product: (DATA && DATA.handle) || '', video_index: current + 1 });
    } catch (e) {}
  }
  function safePlay(v) {
    try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
  }
  function onScreen(v) {
    var r = v.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    var w = window.innerWidth || document.documentElement.clientWidth;
    if (!r.height || !r.width) return false;
    var vy = Math.min(r.bottom, h) - Math.max(r.top, 0);
    var vx = Math.min(r.right, w) - Math.max(r.left, 0);
    return vy / r.height >= 0.5 && vx / r.width >= 0.5;
  }

  /* ---------- small / in-page videos: muted, only while visible ---------- */
  function initInline() {
    inline = Array.prototype.slice.call(document.querySelectorAll('video[data-grv-auto]'));
    if (!inline.length || reduceMotion || saveData || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && !(viewer && !viewer.hidden)) safePlay(v); else v.pause();
      });
    }, { threshold: 0.5 });
    inline.forEach(function (v) { v.muted = true; io.observe(v); });
  }
  function resumeInline() {
    if (reduceMotion || saveData) return;
    inline.forEach(function (v) { if (onScreen(v)) safePlay(v); });
  }

  /* ---------- page's own purchase buttons ---------- */
  function mainForm() {
    return document.querySelector('.product__info-container product-form form[data-type="add-to-cart-form"], product-info product-form form[data-type="add-to-cart-form"], main product-form form[data-type="add-to-cart-form"]');
  }
  function purchaseButton() {
    var form = mainForm();
    if (!form) return null;
    var now = form.querySelector('[data-grable-order-now]');
    if (now && now.style.display !== 'none' && now.getAttribute('aria-disabled') !== 'true') return now;
    var submit = form.querySelector('.product-form__submit');
    return submit && !submit.disabled ? submit : null;
  }
  /* price currently shown on the page (follows the selected variant, e.g. chess set size) */
  function livePrice() {
    var p = document.querySelector('#MainContent .product__info-container [id^="price-"] .price');
    if (!p) return '';
    var el = p.classList.contains('price--on-sale') ? p.querySelector('.price__sale .price-item--sale') : p.querySelector('.price__regular .price-item--regular');
    var t = el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    return t.replace(/\.00\b/, '').replace(/\s*[A-Z]{3}$/, '');
  }
  function buy() {
    track('buy_click');
    var go = function () { var b = purchaseButton(); if (b) b.click(); };
    if (viewer && !viewer.hidden) close(go); else go();
  }

  /* ---------- full-screen viewer ---------- */
  function build() {
    viewer = document.createElement('div');
    viewer.className = 'grv-viewer';
    viewer.hidden = true;
    viewer.setAttribute('role', 'dialog');
    viewer.setAttribute('aria-modal', 'true');
    viewer.setAttribute('aria-label', 'Product video');
    viewer.innerHTML =
      '<div class="grv-viewer__stage">' +
        '<video class="grv-viewer__video" playsinline webkit-playsinline muted preload="auto"></video>' +
        '<div class="grv-viewer__progress"></div>' +
        '<span class="grv-viewer__count" hidden></span>' +
        '<button type="button" class="grv-viewer__sound" hidden aria-label="Turn sound on">' + ICON_MUTED + '</button>' +
        '<button type="button" class="grv-viewer__close" aria-label="Close video">' + ICON_CLOSE + '</button>' +
        '<button type="button" class="grv-viewer__nav grv-viewer__nav--prev" hidden aria-label="Previous video">' + ICON_PREV + '</button>' +
        '<button type="button" class="grv-viewer__nav grv-viewer__nav--next" hidden aria-label="Next video">' + ICON_NEXT + '</button>' +
        '<div class="grv-viewer__paused">' + ICON_PLAY + '</div>' +
        '<div class="grv-viewer__bar">' +
          '<img class="grv-viewer__img" alt="" width="46" height="46">' +
          '<div class="grv-viewer__info"><span class="grv-viewer__title"></span><span class="grv-viewer__price"></span></div>' +
          '<button type="button" class="grv-viewer__buy">Buy Now</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(viewer);
    stage = viewer.querySelector('.grv-viewer__stage');
    video = viewer.querySelector('video');
    progress = viewer.querySelector('.grv-viewer__progress');
    countEl = viewer.querySelector('.grv-viewer__count');
    soundBtn = viewer.querySelector('.grv-viewer__sound');
    prevBtn = viewer.querySelector('.grv-viewer__nav--prev');
    nextBtn = viewer.querySelector('.grv-viewer__nav--next');
    buyBtn = viewer.querySelector('.grv-viewer__buy');
    titleEl = viewer.querySelector('.grv-viewer__title');
    priceEl = viewer.querySelector('.grv-viewer__price');
    imgEl = viewer.querySelector('.grv-viewer__img');

    video.addEventListener('timeupdate', function () {
      var bar = progress.children[current] && progress.children[current].firstChild;
      if (bar && video.duration) bar.style.width = Math.min(100, (video.currentTime / video.duration) * 100) + '%';
    });
    video.addEventListener('ended', function () {
      if (DATA.videos.length > 1) show((current + 1) % DATA.videos.length);
    });
    video.addEventListener('click', function () {
      if (video.paused) { safePlay(video); viewer.classList.remove('is-paused'); }
      else { video.pause(); viewer.classList.add('is-paused'); }
    });
    prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn.addEventListener('click', function () { step(1); });
    viewer.querySelector('.grv-viewer__close').addEventListener('click', function () { close(); });
    viewer.addEventListener('click', function (e) { if (e.target === viewer) close(); });
    soundBtn.addEventListener('click', function () {
      video.muted = !video.muted;
      soundBtn.innerHTML = video.muted ? ICON_MUTED : ICON_SOUND;
      soundBtn.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Turn sound off');
    });
    buyBtn.addEventListener('click', buy);
  }

  function step(dir) {
    var n = DATA.videos.length;
    if (n < 2) return;
    show((current + dir + n) % n);
    track(dir > 0 ? 'next' : 'prev');
  }

  /* load video number i of the page's playlist into the viewer */
  function show(i) {
    var list = DATA.videos;
    current = Math.max(0, Math.min(list.length - 1, i));
    var item = list[current];
    stage.style.setProperty('--grv-ar', item.ar || '.5625');
    video.loop = list.length === 1;
    video.setAttribute('poster', item.poster || '');
    if (video.getAttribute('src') !== item.src) video.setAttribute('src', item.src);
    try { video.currentTime = 0; } catch (e) {}
    Array.prototype.forEach.call(progress.children, function (seg, k) {
      seg.firstChild.style.width = k < current ? '100%' : '0';
    });
    countEl.textContent = (current + 1) + ' / ' + list.length;
    viewer.classList.remove('is-paused');
    safePlay(video);
  }

  function open(trigger) {
    if (!data()) return;
    if (!viewer) build();
    opener = trigger;
    inline.forEach(function (v) { v.pause(); });

    var n = DATA.videos.length, segs = '';
    for (var k = 0; k < n; k++) segs += '<span><i></i></span>';
    progress.innerHTML = segs;
    prevBtn.hidden = nextBtn.hidden = countEl.hidden = n < 2;
    video.muted = true;
    soundBtn.hidden = !DATA.sound;
    soundBtn.innerHTML = ICON_MUTED;

    titleEl.textContent = DATA.title || '';
    var price = livePrice() || DATA.price || '';
    var form = mainForm();
    var nowLabel = form && form.querySelector('[data-grable-order-now] span');
    if (nowLabel && nowLabel.textContent.indexOf('·') > -1) price = nowLabel.textContent.split('·').pop().trim(); /* a pack is selected on the page */
    priceEl.textContent = price;
    if (DATA.image) { imgEl.src = DATA.image; imgEl.style.display = ''; } else { imgEl.style.display = 'none'; }
    buyBtn.hidden = DATA.available === false || !purchaseButton();

    viewer.hidden = false;
    document.body.classList.add('grv-open');
    requestAnimationFrame(function () { viewer.classList.add('is-on'); });
    show(parseInt(trigger.getAttribute('data-grv-index'), 10) || 0);
    try { viewer.querySelector('.grv-viewer__close').focus({ preventScroll: true }); } catch (e) {}
    try { history.pushState({ grv: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
    track('open');
  }

  function hide() {
    if (!viewer || viewer.hidden) return;
    video.pause();
    viewer.classList.remove('is-on');
    viewer.hidden = true;
    document.body.classList.remove('grv-open');
    if (opener) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
    resumeInline();
  }
  function close(cb) {
    if (!viewer || viewer.hidden) { if (cb) cb(); return; }
    if (pushed) {
      /* remove the history entry we added on open; popstate finishes the close */
      afterClose = cb || null;
      pushed = false;
      var done = false;
      var finish = function () { if (done) return; done = true; hide(); var f = afterClose; afterClose = null; if (f) f(); };
      window.addEventListener('popstate', finish, { once: true });
      setTimeout(finish, 500);
      try { history.back(); } catch (e) { finish(); }
    } else {
      hide();
      if (cb) cb();
    }
  }
  /* phone back button closes the viewer instead of leaving the product page */
  window.addEventListener('popstate', function () {
    if (viewer && !viewer.hidden && pushed) { pushed = false; hide(); }
  });
  document.addEventListener('keydown', function (e) {
    if (!viewer || viewer.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') step(1);
    else if (e.key === 'ArrowLeft') step(-1);
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-grv-open]');
    if (t) { e.preventDefault(); open(t); return; }
    var b = e.target.closest && e.target.closest('[data-grv-buy]');
    if (b) { e.preventDefault(); data(); buy(); }
  });

  /* ---------- move the two pieces from the hidden holder into the product page ---------- */
  function place() {
    var src = document.getElementById('GrableRealVideoSrc');
    if (!src) return;
    var info = document.querySelector('#MainContent .product__info-container') || document.querySelector('.product__info-container');
    var teaser = src.querySelector('.grv-teaser');
    var section = src.querySelector('.grv-section');
    if (info) {
      if (teaser) {
        var anchor = null;
        Array.prototype.forEach.call(info.children, function (el) {
          if ((el.id && el.id.indexOf('price-') === 0) || el.classList.contains('product__tax')) anchor = el;
        });
        if (!anchor) anchor = info.querySelector('.product__title');
        if (anchor && anchor.parentNode === info) anchor.insertAdjacentElement('afterend', teaser);
        else info.insertBefore(teaser, info.firstChild);
      }
      if (section) {
        /* Normally the section goes right below the main product block. On templates where an app block
           (e.g. the reviews widget) sits inside the product info column, that would push it under all the
           reviews, so there it goes inside the column instead: after the description / accordions / share. */
        var tail = null, appAfter = false;
        Array.prototype.forEach.call(info.children, function (el) {
          if (el.matches && el.matches('.product__description, .product__accordion, share-button')) tail = el;
        });
        for (var n = tail && tail.nextElementSibling; n; n = n.nextElementSibling) {
          if ((n.id && n.id.indexOf('shopify-block-') === 0) || n.classList.contains('shopify-app-block')) { appAfter = true; break; }
        }
        var main = info.closest('.shopify-section') || info.closest('section');
        if (tail && appAfter) {
          section.classList.add('grv-section--inline');
          tail.insertAdjacentElement('afterend', section);
        } else if (main && main.parentNode) {
          main.insertAdjacentElement('afterend', section);
        }
      }
    }
    src.parentNode.removeChild(src); /* anything not placed is dropped with the holder */
  }

  function init() { place(); initInline(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
